import React, { useContext, useEffect } from 'react'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import './StaticPages.css'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { mapData, handleRedirectInternal, useCustomMediaQuery } from '@/product/common/components'
import UserContext from '@/product/context/user/userContext'
import { useHistory } from 'react-router-dom'
import SEO from '@/utils/SEO'

import AuthContext from '@/product/context/auth/authContext'
import Slider from 'react-slick'
function ContactUs() {
    //subscribers contact page
    const userContext = useContext(UserContext)
    const authContext = useContext(AuthContext)

    const { submitContactUs, responseStatus } = userContext
    const { user, loadUser } = authContext
    const history = useHistory()
    const validationArray = Yup.object({
        first_name: Yup.string()
            .trim()
            .matches(/^[a-zA-Z ]*$/g, 'The special characters not allowed')
            .max(15, 'Maximum 15 characters')
            .required('Required'),
        // last_name: Yup.string()
        //     .trim()
        //     .matches(/^[a-zA-Z ]*$/g, 'The special characters not allowed')
        //     .max(15, 'Maximum 15 characters')
        //     .required('Required'),
        email: Yup.string().email('Invalid email format').required('Required'),
        phone: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .max(16, 'Maximum 11 Number')
            .min(15, 'Invalid Phone Number')
            .required('Required!'),
        state: Yup.string().required('Required'),
        message: Yup.string().required('Required'),
    })

    //Form fields
    const formik = useFormik({
        initialValues: {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            state: '',
            city: '',
            message: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            submitContactUs(values)
        },
    })

    //submission of form
    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'submitContactUs') {
                if (responseStatus.status === 'success') {
                    handleRedirectInternal(history, '')
                }
            }
        }
    }, [responseStatus])

    const contactInfo = [
        {
            label: 'First Name',
            name: 'first_name',
            type: 'text',
            placeholder: 'First Name',
            class: 'col-6',
            formik: formik,
        },
        {
            label: 'Last Name',
            name: 'last_name',
            type: 'text',
            placeholder: 'Last Name',
            class: 'col-6',
            formik: formik,
        },
        // {
        //     label: 'Last name',
        //     name: 'last_name',
        //     type: 'text',
        //     placeholder: 'Enter your last name',
        //     class: 'col-sm-6 col-12',
        //     formik: formik,
        // },
        {
            label: 'Email',
            name: 'email',
            type: 'text',
            placeholder: 'Email',
            class: 'col-12',
            formik: formik,
        },
        {
            label: 'Mobile Number *',
            name: 'phone',
            type: 'phone',
            placeholder: 'Mobile Number',
            class: 'col-12',
            formik: formik,
        },
        // {
        //     label: 'City',
        //     name: 'city',
        //     type: 'text',
        //     placeholder: 'City',
        //     class: 'col-6',
        //     formik: formik,
        // },
        {
            label: 'Location',
            name: 'state',
            type: 'text',
            placeholder: 'State',
            class: 'col-12',
            formik: formik,
        },
        {
            label: 'Message',
            name: 'message',
            type: 'textarea',
            placeholder: '',
            class: 'col-12',
            formik: formik,
        },
    ]

    useEffect(() => {
        if (user) {
            console.log('user.phone', user.phone, typeof user.phone)
            formik.setValues({
                ...formik.values,
                first_name: user.first_name || '',
                last_name: user.last_name || '',
                email: user.email || '',
                phone: user.phone || '',
                city: user.city || '',
                state: user.state || '',
            })
        }
    }, [user])

    const settings = {
        dots: false,
        arrows: true,
        fade: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 6000,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }

    const isMobileView = useCustomMediaQuery('(width <= 600px)')

    return (
        <>
            <SEO title="Contact Us" url={window.location.href} />
            <div className="contact-main-container">
                <div className="contact-inside-Box">
                    <div className="row">
                        <div className="col-md-7 contact-us-banner-column">
                            <div className="contact-us-banner text-center">
                                <img
                                    alt="contactus-imageContainer"
                                    src="assets/images/contact-us.png"
                                    className="contactus-imageContainer"
                                ></img>
                            </div>
                            {!isMobileView && (
                                <div className="contact-us-detail desktop-view">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="contact-us-detail-no text-left">
                                                <h4>Contact us</h4>
                                                <ul>
                                                    <li>
                                                        <img
                                                            src="assets/images/icons/call.svg"
                                                            alt="call"
                                                        />
                                                        <a href="tel:080-6905-0000">
                                                            Toll Free - 080-6905-0000
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <img
                                                            src="assets/images/icons/email.svg"
                                                            alt="email"
                                                        />
                                                        <a href="mailto:customercare@iquippo.com">
                                                            customercare@iquippo.com
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="contact-us-detail-no text-left">
                                                <h4>Grievance Officer</h4>
                                                <ul className="officer">
                                                    <li>
                                                        <img
                                                            src="assets/images/icons/account.svg"
                                                            alt="account"
                                                        />
                                                        <span>
                                                            Gaurav Sharma,
                                                            <span className="designation">
                                                                Marketing & Customer Solutions
                                                            </span>
                                                        </span>
                                                    </li>
                                                    <li>
                                                        <img
                                                            src="assets/images/icons/call.svg"
                                                            alt="call"
                                                        />
                                                        <a href="tel:8826816813">8826816813</a>
                                                    </li>
                                                    <li>
                                                        <img
                                                            src="assets/images/icons/email.svg"
                                                            alt="email"
                                                        />
                                                        <a href="mailto:gaurav.sharma@iquippo.com">
                                                            gaurav.sharma@iquippo.com
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="col-md-5 contact-us-form-column">
                            <form onSubmit={formik.handleSubmit} className="contact-us-form">
                                <div className="contact-form-box">
                                    <div className="contact-form">
                                        <h3>Lets talk</h3>
                                        <p>
                                            To request a quote or want to meet up for coffee.
                                            Contact us directly or fill out the form and we will get
                                            back to you.
                                        </p>
                                        <div className="row">
                                            {Object.values(mapData(contactInfo))}
                                            <div className="col-12">
                                                <PrimaryButton
                                                    id="contactUs_submit_form"
                                                    label={'Submit'}
                                                    type="submit"
                                                    className="gradientVarient"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    {isMobileView && (
                        <div className="contact-us-detail desktop-view px-4">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="contact-us-detail-no text-left">
                                        <h4>Contact us</h4>
                                        <ul>
                                            <li>
                                                <img
                                                    src="assets/images/icons/call.svg"
                                                    alt="call"
                                                />
                                                <a href="tel:080-6905-0000">
                                                    Toll Free - 080-6905-0000
                                                </a>
                                            </li>
                                            <li>
                                                <img
                                                    src="assets/images/icons/email.svg"
                                                    alt="email"
                                                />
                                                <a href="mailto:customercare@iquippo.com">
                                                    customercare@iquippo.com
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="contact-us-detail-no text-left">
                                        <h4>Grievance Officer</h4>
                                        <ul className="officer">
                                            <li>
                                                <img
                                                    src="assets/images/icons/account.svg"
                                                    alt="account"
                                                />
                                                <span>
                                                    Gaurav Sharma,
                                                    <span className="designation">
                                                        Marketing & Customer Solutions
                                                    </span>
                                                </span>
                                            </li>
                                            <li>
                                                <img
                                                    src="assets/images/icons/call.svg"
                                                    alt="call"
                                                />
                                                <a href="tel:8826816813">8826816813</a>
                                            </li>
                                            <li>
                                                <img
                                                    src="assets/images/icons/email.svg"
                                                    alt="email"
                                                />
                                                <a href="mailto:gaurav.sharma@iquippo.com">
                                                    gaurav.sharma@iquippo.com
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="contact-us-location mobile-view">
                        <div className="row">
                            <div className={`col-md-12 ${isMobileView ? '' : 'p-0'}`}>
                                <Slider {...settings}>
                                    <div className="address-here mb-3">
                                        <div className="addess-container">
                                            <div className="loaction-title">
                                                <img
                                                    src="assets/images/icons/location.svg"
                                                    alt="location"
                                                    className="locIco"
                                                />
                                                <span className="">Register Office</span>
                                            </div>
                                            <div className="loaction-subtitle">
                                                <p>iQuippo Services Pvt. Ltd.</p>
                                                <p>Tangra Industrial Estate, Phase - II</p>
                                                <p>45 Radhanath Chowdhury Road Kolkata - 700015</p>
                                            </div>
                                        </div>
                                        <div className="map mt-3">
                                            <iframe
                                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.1309569342234!2d88.43200297522122!3d22.574204879490566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0275af23422421%3A0x397d84683bbd8409!2siQuippo%2C%20India's%20leading%20marketplace%20for%20equipment%20and%20services!5e0!3m2!1sen!2sin!4v1681903041427!5m2!1sen!2sin"
                                                width="100%"
                                                height="300"
                                                style={{ border: 0 }}
                                                loading="lazy"
                                                allowFullScreen
                                                referrerPolicy="no-referrer-when-downgrade"
                                                title="iQuippo Location"
                                            ></iframe>
                                        </div>
                                    </div>
                                    <div className="address-here mb-3">
                                        <div className="addess-container">
                                            <div className="loaction-title">
                                                <img
                                                    src="assets/images/icons/location.svg"
                                                    alt="location"
                                                    className="locIco"
                                                />
                                                <span className="">Delhi NCR Office</span>
                                            </div>
                                            <div className="loaction-subtitle">
                                                <p>iQuippo Services Pvt. Ltd.</p>
                                                <p>
                                                    6th Floor, Plot.no. 14A Sector 18, Maruti
                                                    Industrial Complex,
                                                </p>
                                                <p>Gurugram, Haryana - 122015</p>
                                            </div>
                                        </div>
                                        <div className="map mt-3">
                                            <iframe
                                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.5934092209764!2d77.07318831507938!3d28.491788982473643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d19145c2f795b%3A0xb9d31acf169ee777!2siQuippo%20Marketplace%20-%20Buy%20%7C%20Sell%20%7C%20Finance%20%7C%20Auctions!5e0!3m2!1sen!2sin!4v1642415416768!5m2!1sen!2sin"
                                                width="100%"
                                                height="300"
                                                style={{ border: 0 }}
                                                loading="lazy"
                                                allowFullScreen
                                                referrerPolicy="no-referrer-when-downgrade"
                                                title="iQuippo Location"
                                            ></iframe>
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactUs
